import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogConfig } from 'app/shared/dialog';
import { ToastrService } from 'ngx-toastr';
import { DataShareService } from '../../../services/data-share.service';
import { AccountMembership, APIService, Contact, UploadedFile } from '../../API.service.custom';
import { LatestInteraction } from '../../contacts/contact-detail/contact-detail.component';
import * as globalFunctions from './../../../globals/functions';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { TitleCasePipe } from '@angular/common';
import { FormatEnumPipe } from '../../../services/format-enum.pipe';

@Component({
    selector: 'app-in-call',
    templateUrl: './in-call.component.html',
    styleUrls: ['./in-call.component.scss'],
    imports: [MatChipListbox, MatChipOption, TitleCasePipe, FormatEnumPipe]
})
export class InCallComponent implements OnInit {
  contactId : string = null;
  title : string = "On Call"
  latestInteraction: LatestInteraction = {};
  isLoading = true;
  callingScripts : UploadedFile[] = [];

  callScript : string = null

  activeAccount : AccountMembership = null;
  activAccountSubscription;
  callScriptsSubscription;
  contact : Contact = null;

  constructor(
    private config: DialogConfig,
    private dataService: DataShareService,
    private api: APIService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const configData = this.config.data;
    if (configData && configData.contactId) {
      this.contactId = configData.contactId;
    }
    if (configData && configData.title) {
      this.title = configData.title;
    }

    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
        this.activeAccount = param;
        console.log("+++++++++++++ In CallComponent. The active account is :", this.activeAccount);
        if (this.contactId) {
          this.api.GetContact(this.contactId).then(event => {
            console.log('Contact Under Processing Fetched : ', event);
            this.contact = event;
            this.isLoading = false;
            this.latestInteraction = this.getLatestInteraction(this.contact);
            // this.getActiveDeals();
            // this.getOpenTasks();
          })
          .catch(e => {
            console.log('Error Fetching Contact with given id', e);
            this.isLoading = false;
            this.showErrorInToastr(e, 'Error Fetching Contact');
            this.router.navigate(['/leads']);
          });
      }
    }
  });

  this.callScriptsSubscription = this.dataService.getCallingScripts().subscribe((param_script: any) => {
    if (param_script) {
      this.callingScripts = param_script;
      if(this.callingScripts && this.callingScripts.length > 0)
        this.callScript = this.callingScripts[0].templateBody
    }else{
      this.callScript = null
    }
  })
    
  }

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
      this.activAccountSubscription.unsubscribe();
    if (this.callScriptsSubscription && !this.callScriptsSubscription.closed)
      this.callScriptsSubscription.unsubscribe();
  }

  getLatestInteraction(contact: Contact): LatestInteraction {
    let interaction = <LatestInteraction>{};
    interaction.accountName = this.activeAccount.account.accountName;
    interaction.leadName = contact.name;
    interaction.hasTask = contact.hasTask;
    interaction.openTaskActivityType = contact.openTaskActivityType;
    if (contact.lastCalledTime != null && contact.lastCalledTime != '')
      interaction.lastCalledTime = globalFunctions.readableDateFormatter({ value: contact.lastCalledTime });
    interaction.lastCallDirection = contact.lastCallDirection;
    interaction.lastCallOutcome = globalFunctions.readableEnumFormatter({ value: contact.lastCallOutcome });
    if (contact.lastCallDuration)
      interaction.lastCallDuration = contact.lastCallDuration / 1000;
    if (contact.lastVisitTime != null && contact.lastVisitTime != '')
      interaction.lastVisitTime = globalFunctions.readableDateFormatter({ value: contact.lastVisitTime });
    interaction.lastVisitOutcome = globalFunctions.readableEnumFormatter({ value: contact.lastVisitOutcome });
    if (contact.lastEmailTime != null && contact.lastEmailTime != '')
      interaction.lastEmailTime = globalFunctions.readableDateFormatter({ value: contact.lastEmailTime });
    if (contact.lastWhatsappTime != null && contact.lastWhatsappTime != '')
      interaction.lastWhatsappTime = globalFunctions.readableDateFormatter({ value: contact.lastWhatsappTime });
    interaction.lastKnownDisposition = globalFunctions.readableEnumFormatter({ value: contact.lastKnownDisposition });
    if (contact.lastEngagementFromAccount != null && contact.lastEngagementFromAccount != '')
      interaction.lastEngagementFromAccount = globalFunctions.readableDateFormatter({ value: contact.lastEngagementFromAccount });
    if (contact.lastEngagementFromContact != null && contact.lastEngagementFromContact != '')
      interaction.lastEngagementFromContact = globalFunctions.readableDateFormatter({ value: contact.lastEngagementFromContact });
    if (contact.lastCallUser)
      interaction.lastCallUserName = contact.lastCallUser.name;
    if (contact.lastVisitUser)
      interaction.lastVisitUserName = contact.lastVisitUser.name;
    interaction.lastCallUserId = contact.lastCallUserId;
    if (contact.lastEmailUser)
      interaction.lastEmailUserName = contact.lastEmailUser.name;
    if (contact.lastWhatsappUser)
      interaction.lastWhatsappUserName = contact.lastWhatsappUser.name;
    interaction.lastVisitUserId = contact.lastVisitUserId;
    interaction.lastEmailUserId = contact.lastEmailUserId;
    interaction.lastWhatsappUserId = contact.lastWhatsappUserId;
    interaction.lastCallEngagementId = contact.lastCallEngagementId;
    interaction.lastVisitEngagementId = contact.lastVisitEngagementId;
    interaction.lastEmailEngagementId = contact.lastEmailEngagementId;
    interaction.lastWhatsappEngagementId = contact.lastWhatsappEngagementId;
    interaction.lastNoteAddedTime = globalFunctions.readableDateFormatter({ value: contact.lastNoteAddedTime });
    interaction.lastNoteUserId = contact.lastNoteUserId;
    if (contact.lastNoteUser)
      interaction.lastNoteUserName = contact.lastNoteUser.name;
    interaction.lastNoteEngagementId = contact.lastNoteEngagementId;
    interaction.lastTaskDoneTime = globalFunctions.readableDateFormatter({ value: contact.lastTaskDoneTime });
    interaction.lastTaskDoneUserId = contact.lastTaskDoneUserId;
    if (contact.lastTaskDoneUser)
      interaction.lastTaskDoneUserName = contact.lastTaskDoneUser.name;
    interaction.lastTaskDoneEngagementId = contact.lastTaskDoneEngagementId;
    interaction.openTaskCount = contact.openTaskCount;
    interaction.lastKnownDispositionTime = globalFunctions.readableDateFormatter({ value: contact.lastKnownDispositionTime });
    return interaction;
  }


  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }

}
